import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import( '../views/Home.vue')
  },
  {
    path: '/password-lost',
    name: 'PasswordLost',
    component: () => import( '../views/PasswordLost.vue')
  },
  {
    path: '/password-reset/:id/:token',
    name: 'PasswordReset',
    component: () => import( '../views/PasswordReset.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import( '../views/News.vue'),
    meta: {
      requiresAuth: true,
      permission: 'news'
    }
  },
  {
    path: '/events',
    name: 'Events',
    component: () => import( '../views/Events.vue'),
    meta: {
      requiresAuth: true,
      permission: 'events'
    }
  },
  {
    path: '/press-release',
    name: 'PressRelease',
    component: () => import( '../views/PressRelease.vue'),
    meta: {
      requiresAuth: true,
      permission: 'press_release'
    }
  },
  {
    path: '/press-review',
    name: 'PressReview',
    component: () => import( '../views/PressReview.vue'),
    meta: {
      requiresAuth: true,
      permission: 'press_review'
    }
  },
  {
    path: '/career',
    name: 'Career',
    component: () => import( '../views/Career.vue'),
    meta: {
      requiresAuth: true,
      permission: 'career'
    }
  },
  {
    path: '/documents',
    name: 'Documents',
    component: () => import( '../views/Documents.vue'),
    meta: {
      requiresAuth: true,
      permission: 'documents'
    }
  },
  {
    path: '/shareholders-meetings',
    name: 'ShareholdersMeeting',
    component: () => import( '../views/ShareholdersMeeting.vue'),
    meta: {
      requiresAuth: true,
      permission: 'shareholders'
    }
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: () => import( '../views/Calendar.vue'),
    meta: {
      requiresAuth: true,
      permission: 'calendar'
    }
  },
  {
    path: '/ifu-lots',
    name: 'IfuLots',
    component: () => import( '../views/IfuLots.vue'),
    meta: {
      requiresAuth: true,
      permission: 'ifu'
    }
  },
  {
    path: '/add/:cat',
    name: 'AddForm',
    component: () => import( '../views/AddForm.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/update/:post',
    name: 'UpdateForm',
    component: () => import( '../views/UpdateForm.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/add-calendar',
    name: 'AddCalendar',
    component: () => import( '../views/AddCalendar.vue'),
    meta: {
      requiresAuth: true,
      permission: 'calendar'
    }
  },
  {
    path: '/update-calendar/:event',
    name: 'UpdateCalendar',
    component: () => import( '../views/UpdateCalendar.vue'),
    meta: {
      requiresAuth: true,
      permission: 'calendar'
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import( '../views/Users.vue'),
    meta: {
      requiresAuth: true,
      permission: 'users'
    }
  },
  {
    path: '/roles',
    name: 'Roles',
    component: () => import( '../views/Roles.vue'),
    meta: {
      requiresAuth: true,
      permission: 'users'
    }
  },
  {
    path: '/no-access',
    name: 'NoAccess',
    component: () => import( '../views/NoAccess.vue'),
    meta: {
      requiresAuth: true
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {

      return { el: to.hash, behavior: 'smooth' }
    }
    return { top: 0 }
  }
})

/* Menus in display order: route name => permission */
export const menuRoutes = [
  ['News', 'news'],
  ['Events', 'events'],
  ['PressRelease', 'press_release'],
  ['PressReview', 'press_review'],
  ['Documents', 'documents'],
  ['IfuLots', 'ifu'],
  ['ShareholdersMeeting', 'shareholders'],
  ['Career', 'career'],
  ['Calendar', 'calendar'],
  ['Users', 'users']
]

/* Post category (add form) => permission */
const catPermissions = {
  1 : 'news', 2 : 'events', 3 : 'press_release', 4 : 'press_review',
  5 : 'career', 6 : 'documents', 7 : 'shareholders'
}

const firstAllowedRoute = () => {
  const found = menuRoutes.find(([, permission]) => store.getters.can(permission))
  return found ? { name : found[0] } : { name : 'NoAccess' }
}

const canOpen = (to) => {
  const permission = to.meta.permission
    || (to.name == 'AddForm' ? catPermissions[to.params.cat] || 'none' : null)
  if(to.name == 'UpdateForm') {
    // the category is checked by the API when the post is loaded
    return Object.values(catPermissions).some((p) => store.getters.can(p))
  }
  return !permission || store.getters.can(permission)
}

/* verification qu'on est connecté (et qu'on a le droit d'y accéder) sinon on redirige */
router.beforeEach(async (to, from, next) => {
  if(!to.matched.some(record => record.meta.requiresAuth)) {
    next()
    return
  }
  if(!localStorage._safeToken) {
    next('/')
    return
  }
  // rights are refreshed from the API when unknown or older than one minute
  if(!store.state.user || Date.now() - store.state.userLoadedAt > 60000) {
    const valid = await store.dispatch('loadMe')
    if(!valid) {
      localStorage.removeItem('_safeToken')
      next('/')
      return
    }
  }
  if(canOpen(to)) {
    next()
    return
  }
  next(firstAllowedRoute())
})

export default router
